import React, { ReactElement } from 'react';
import { Box, Image, Text, VStack } from '@chakra-ui/react';
import { VideoBox } from 'components/common/VideoBox/VideoBox';
import placeholder from 'assets/common/placeholder.png';
import { NHVideoBlockProps } from '../NHVideoBlock';

type Props = NHVideoBlockProps;

export const StudentNHVideoBlock = ({ block }: Props): ReactElement => {
  return (
    <VStack width="100%" gap="15px" alignItems="center" contentEditable={false}>
      <Box
        borderRadius="l"
        overflow="hidden"
        flexGrow={1}
        width="500px"
        maxWidth="100%"
        height={{ base: '200px', md: '300px' }}
        maxHeight={{ base: '200px', md: '300px' }}
        position="relative"
        display="block"
        cursor="pointer"
      >
        {block.props.videoUrl ? (
          <VideoBox
            videoUrl={block.props.videoUrl}
            videoDescription={block.props.description}
            isEmbedded
            thumbnailUrl={block.props.thumbnailUrl}
          />
        ) : (
          <Image
            src={placeholder}
            alt="Video Thumbnail"
            borderRadius="l"
            objectFit="cover"
            cursor="pointer"
            transition="transform 0.2s"
          />
        )}
      </Box>
      <VStack gap="10px" textAlign="center">
        <Text textStyle="body.m.medium">{block.props.title}</Text>

        <Text textStyle="body.s.regular" fontFamily="Lato, sans-serif" color="text.tertiary">
          {block.props.description}
        </Text>
      </VStack>
    </VStack>
  );
};
